import FormSelectInput from 'common/FormSelectInput';
import FormTextInput from 'common/FormTextInput';
import { states } from 'pages/Business/Provider/ProviderPopup/Partials/constants';

export default function BoardCertification({
    count,
    formData,
    handleChange,
    extraBoardCertification,
    extraBoardCertificationState,
    extraBoardCertificationYear,
}) {
    return (
        <>
            <FormTextInput
                // formData={formData}
                name="board_certification"
                value={extraBoardCertification?.[count]}
                handleChange={handleChange}
                placeholder="Enter a certification name"
                required={false}
                labelSize={0}
                textSize={6}
                noLabel={true}
                inputProps={{ autoComplete: 'off' }}
            />

            <FormSelectInput
                // formData={formData}
                name="board_certification_state"
                value={extraBoardCertificationState?.[count] ?? ""}
                handleChange={handleChange}
                placeholder="State"
                required={false}
                labelSize={0}
                inputSize={3}
                noLabel={true}
                options={states}
                optionValue={['abbreviation']}
                optionKey={'abbreviation'}
                disabled={false}
            />

            <FormTextInput
                // formData={formData}
                name="board_certification_year"
                value={extraBoardCertificationYear?.[count]}
                handleChange={handleChange}
                placeholder="Year"
                required={false}
                labelSize={0}
                textSize={3}
                noLabel={true}
                disabled={false}
            />
        </>
    );
}
